import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomCalendarRange = ({
    isClearable = false,
    className = "",
    holder = "Selecciona rango de fechas",
    valueStart = null,
    valueEnd = null,
    filters,
    setFilters,
}) => {
    const usesCamelCaseKeys = useMemo(
        () => Object.prototype.hasOwnProperty.call(filters || {}, "startDate") || Object.prototype.hasOwnProperty.call(filters || {}, "endDate"),
        [filters]
    );

    const [dateRange, setDateRange] = useState([valueStart, valueEnd]);
    const [startDate, endDate] = dateRange;

    useEffect(() => {
        setDateRange([valueStart || null, valueEnd || null]);
    }, [valueStart, valueEnd]);

    const onChange = (update) => {
        const nextRange = update || [null, null];
        setDateRange(nextRange);

        if (setFilters && typeof setFilters === "function") {
            const [nextStartDate, nextEndDate] = nextRange;

            setFilters({
                ...filters,
                ...(usesCamelCaseKeys
                    ? {
                        startDate: nextStartDate || "",
                        endDate: nextEndDate || "",
                    }
                    : {
                        start_date: nextStartDate || "",
                        end_date: nextEndDate || "",
                    }),
                page: 1,
            });
        }
    };

    return (
        <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={onChange}
            isClearable={isClearable}
            placeholderText={holder}
            className={`w-full border border-gray-300 mt-1 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-fr-primary focus:border-fr-primary ${className}`}
            dateFormat="yyyy/MM/dd"
            popperClassName="z-[9999]"
        />
    );
};

export default CustomCalendarRange;
